export const SCREENER_SESSION_STATUS = {
  OUTDATED: 'outdated',
};

export const SCREENER_SESSION_ERROR = {
  OUTDATED: 'OUTDATED_SCREENER_SURVEY',
};
